import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\Dropdown.tsx.esbuild-plugin-linaria.css';
import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\Dropdown.tsx.esbuild-plugin-windicss.css';
import { css, cx } from '@linaria/core';
import { mdiMenuDown } from '@mdi/js';
import { memo } from 'preact/compat';
import { useCallback, useEffect, useRef } from 'preact/hooks';
import { StyleType } from '../../doodle/view/StyleType';
import { COLOR_DROPDOWN_BACK, COLOR_DROPDOWN_SHADOW } from '../colors';
import { ToolbarButton } from './ToolbarButton';
const caretIcon = <svg viewBox="0 0 24 24" width="20" height="20" class="-mr-1">
    <path fill="currentColor" d={mdiMenuDown} />
  </svg>;
export const Dropdown = memo(({
  containerClass,
  dropdownClass,
  buttonClass,
  buttonStyle,
  alignment,
  disabled,
  caret,
  isOpen,
  setOpen,
  children
}: {
  containerClass?: string;
  dropdownClass?: string;
  buttonClass?: string;
  buttonStyle?: StyleType;
  alignment?: 'left' | 'right';
  disabled?: boolean;
  caret?: boolean;
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  children: [any, any];
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const onPointerDown = (event: PointerEvent) => !ref.current?.contains(event.target as Element) && setOpen(false);
    addEventListener('pointerdown', onPointerDown, true);
    return () => removeEventListener('pointerdown', onPointerDown, true);
  }, [setOpen]);
  const close = useCallback(() => setOpen(!isOpen), [isOpen, setOpen]);
  return <div ref={ref} class={cx('relative', containerClass)}>
        <ToolbarButton active={isOpen} className={buttonClass} style={buttonStyle} disabled={disabled} onClick={close}>
          {children[0]}
          {caret !== false && caretIcon}
        </ToolbarButton>
        <div className={cx('absolute top-full flex w-max', "d1mk7ty3", alignment === 'right' ? 'right-0 justify-end' : 'left-0', !isOpen && 'opacity-0 w-0 overflow-hidden pointer-events-none', dropdownClass)}>
          {children[1]}
        </div>
      </div>;
});